// src/pages/speaker/Index.jsx

import React, { useState, useEffect } from "react";
import { Users } from "lucide-react";
import SpeakerCard from "../../components/Speaker/SpeakerCard";
import Header from "../../components/LandingPage/Header";
import Pagination from "../../components/LandingPage/Pagination"; 
import LoadingCircle from "../../components/Common/LoadingCircle";
import { getDataByAll } from "../../api/speakerApi";

const SpeakerIndex = () => {
  const [datas, setSDatas] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    getDataByAll()
      .then((res) => setSDatas(res))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredSpeakers = datas.filter(s => 
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.topic.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Logika Slice untuk Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSpeakers.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <section className="min-h-screen bg-slate-50/30 dark:bg-slate-950 flex flex-col items-center justify-center">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving Speakers Data...
        </p>
      </section>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50/30 dark:bg-slate-950 pt-32 lg:pt-44 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <Header 
          title="All Speakers"
          subtitle="Professional Directory"
          placeholder="Search speakers or topics..."
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          icon={Users} 
        />

        {/* Main */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {currentItems.length > 0 ? (
            currentItems.map((s, i) => <SpeakerCard key={s.id} speaker={s} index={i} />)
          ) : (
            <div className="col-span-full py-20 text-center text-slate-400 font-bold uppercase tracking-widest">
              No data found.
            </div>
          )}
        </div>
        
        {/* Pagination */}
        <Pagination 
          totalItems={filteredSpeakers.length}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default SpeakerIndex;